var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17277 10.8333C7.74807 10.8333 8.21444 10.367 8.21444 9.79167C8.21444 9.21637 7.74807 8.75 7.17277 8.75C6.59747 8.75 6.1311 9.21637 6.1311 9.79167C6.1311 10.367 6.59747 10.8333 7.17277 10.8333Z",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17277 5.41665C7.74807 5.41665 8.21444 4.95028 8.21444 4.37498C8.21444 3.79968 7.74807 3.33331 7.17277 3.33331C6.59747 3.33331 6.1311 3.79968 6.1311 4.37498C6.1311 4.95028 6.59747 5.41665 7.17277 5.41665Z",
    fill: "#8395A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17277 16.25C7.74807 16.25 8.21444 15.7836 8.21444 15.2083C8.21444 14.633 7.74807 14.1666 7.17277 14.1666C6.59747 14.1666 6.1311 14.633 6.1311 15.2083C6.1311 15.7836 6.59747 16.25 7.17277 16.25Z",
    fill: "#8395A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5895 10.8333C13.1648 10.8333 13.6312 10.367 13.6312 9.79167C13.6312 9.21637 13.1648 8.75 12.5895 8.75C12.0142 8.75 11.5479 9.21637 11.5479 9.79167C11.5479 10.367 12.0142 10.8333 12.5895 10.8333Z",
    fill: "#8395A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5895 5.41665C13.1648 5.41665 13.6312 4.95028 13.6312 4.37498C13.6312 3.79968 13.1648 3.33331 12.5895 3.33331C12.0142 3.33331 11.5479 3.79968 11.5479 4.37498C11.5479 4.95028 12.0142 5.41665 12.5895 5.41665Z",
    fill: "#8395A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5895 16.25C13.1648 16.25 13.6312 15.7836 13.6312 15.2083C13.6312 14.633 13.1648 14.1666 12.5895 14.1666C12.0142 14.1666 11.5479 14.633 11.5479 15.2083C11.5479 15.7836 12.0142 16.25 12.5895 16.25Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.a174bbb2f7e35331440ea2f66c6ba04e.svg";
export { ForwardRef as ReactComponent };